import React from "react";
import ReactDOM from "react-dom/client";
import { PostHogProvider } from "@posthog/react";
import posthog from "posthog-js";
import App from "./App";
import { ThemeProvider } from "./contexts/ThemeContext";
import { logVersionInfo } from "./utils/version";
import { analyticsService } from "./services/analytics/analyticsService";
import "./i18n";
import "./index.css";

// Log version information on app initialization
logVersionInfo();

analyticsService.initialize();

// App component wrapped with providers
const app = (
  <PostHogProvider client={posthog}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </PostHogProvider>
);

// Thorium EPUB reader library doesn't support React Strict Mode
// Strict Mode disabled in development to ensure reader works after client-side navigation
// IMPORTANT: This must be disabled because Thorium providers fail silently under Strict Mode
ReactDOM.createRoot(document.getElementById("root")!).render(app);
